'use client'

import type { HTMLAttributeAnchorTarget } from 'react'
import Link from 'next/link'

import { DropdownMenuItem } from '@ui/web/components'

import { useIsActive } from './use-is-active'

interface DropdownNavButtonProps {
  href: string
  target?: HTMLAttributeAnchorTarget
  text: string
}

export function DropdownNavButton({ href, target, text }: DropdownNavButtonProps) {
  const isActive = useIsActive(href, target)

  return (
    <DropdownMenuItem
      key={href}
      render={(() => {
        if (isActive) {
          return (
            <span
              aria-current='page'
              className='text-neutral-black hover:text-neutral-black bg-blue-30 hover:bg-blue-30'
            >
              {text}
            </span>
          )
        }

        return (
          <Link href={href} target={target} prefetch={target !== '_blank'}>
            {text}
          </Link>
        )
      })()}
    />
  )
}
